import { useEffect, useMemo, useState } from "react";

import { Box, CssBaseline, ThemeProvider } from "@mui/material";

//import { easyMapsTheme } from "../../themes/themeEasyReport";
import { Outlet, useLocation } from "react-router-dom";
import { ReactComponent as IconLogo } from "../../assets/easyMaps/logoEasyMaps.svg";

//import { ReactComponent as PerfilReportSvg } from "../../assets/easyReport/iconSvg/perfilReport.svg";
import easyMapsTheme from "../../themes/easyMapsTheme";
import TopBar from "../../componentes/topBar";

import {
  MapOutlined,
  PlaylistAdd,
  WorkspacesOutlined,
} from "@mui/icons-material";
import SideBar from "../../componentes/sideBar";
import ConfiguracaoEasyMapsModal from "../../componentes/easyMaps/configModal";
import Config from "./config";
import api from "../../services/api";
import ModulesAlert from "../../componentes/modulesAlert";
import MapActionsContext from "../../contexts/mapActionsContext";
import usePermissao from "../../hooks/usePermissao";

function LayoutEasyMaps(params) {
  const {
    colorMode,
    setColorMode,
    socket,
    socketCliente,
    setCheckLogin,
    modulos,
  } = params;
  const theme = useMemo(() => easyMapsTheme(colorMode), [colorMode]);
  const location = useLocation(); // Se estiver usando React Router
  const [snackbar, setSnackbar] = useState(null);
  const [openRightBar, setOpenRightBar] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openConfig, setOpenConfig] = useState({ open: false, tab: 0 });
  const [showSidebar, setShowSidebar] = useState(true);
  const [config, setConfig] = useState(null);
  const [configLocal, setConfigLocal] = useState(null);
  const [configLayer, setConfigLayer] = useState(null);
  const [titlePage, setTitlePage] = useState("");
  const [maps, setMaps] = useState([]);
  const [menuConfig, setMenuConfig] = useState(null);
  const clientLogo =
    theme.palette.mode === "dark"
      ? `${
          window?.config?.REACT_APP_LOGO_EASY_MAPS_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_EASY_MAPS_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_EASY_MAPS_URL || ""}`;

  const easyMapsOnly =
    window?.config?.REACT_APP_EASYMAPS_ONLY === "true" || false;
  const { canEdit } = usePermissao("easyMaps");

  const styles = {
    containerLayout: {
      display: "flex",
      width: "100%",
      height: "fit-content",
      flexDirection: "column",
    },
    containerBody: {
      display: "flex",
      width: "100%",
      height: "100%",
      minWidth: "350px",
    },
    containerOutlet: {
      flexGrow: 1,
      width: "100%",
      //paddingTop: 5, paddingInline: 3
      padding: showSidebar ? 4 : 0,
      gap: 3,
    },
  };
  //const PerfilReport = createSvgIcon(<PerfilReportSvg />);
  const rightBarPages = [
    {
      itemId: "1",
      label: "Início",
      link: "/easyMaps/inicio",
      icon: <WorkspacesOutlined />,
    },
    {
      openItem: true,
      itemId: "2",
      label: "Mapas Geolocalizados",
      icon: <MapOutlined />,
      nodes: [
        {
          itemId: "2.1",
          label: "Backbone",
          link: "/easyMaps/mapas/geolocalizado",
        },
        {
          itemId: "2.2",
          label: "FTTH",
          link: "/easyMaps/mapas/ftth",
        },
      ],
    },
    {
      openItem: true,
      itemId: "3",
      label: "Mapas de Topologia",
      icon: <MapOutlined />,
      nodes: [
        {
          itemId: "3.1",
          label: "Infraestrutura",
          link: "/easyMaps/mapas/topologia",
        },
        {
          itemId: "3.2",
          label: "POP's",
          link: "/easyMaps/mapas/pop",
        },
      ],
    },
    ...(easyMapsOnly && canEdit
      ? [
          {
            itemId: "4",
            label: "Adição de Host",
            link: "/easyMaps/addHosts",
            icon: <PlaylistAdd />,
            group: "Navegação",
          },
        ]
      : []),
    // {
    //   itemId: "3",
    //   label: "POP's",
    //   link: "/easyMaps/mapas/pop",
    //   icon: <RouteOutlined />,
    // },
  ];

  useEffect(() => {
    setShowSidebar(!location.pathname.includes("/easyMaps/mapa/"));
    const hierarchy = findTitleHierarchy(rightBarPages, location.pathname);
    setTitlePage(hierarchy);
  }, [location.pathname]);

  useEffect(() => {
    handleApiGetConfig();
  }, []);

  // ---- Garante caso o cofig seja mudando por outro instância, o cliente atualize
  useEffect(() => {
    function setChangeConfig(response) {
      if (response.status === 200) {
        // Preserva o flag de runtime redisDisponivel, que não vem no payload do
        // socket (é resolvido só no GET inicial /settings/find).
        setConfig((prev) => ({
          ...(response?.data?.config || {}),
          redisDisponivel:
            response?.data?.config?.redisDisponivel ?? prev?.redisDisponivel,
        }));
      }
    }
    socketCliente.on("onChangeConfig", setChangeConfig);
    // Limpa o listener quando o componente desmonta ou dependências mudam
    return () => {
      socketCliente.off("onChangeConfig", setChangeConfig);
    };
  }, []);
  // atualizações do layer nos mapas
  useEffect(() => {
    if (!configLayer) return;
    sessionStorage.setItem("easyMapsLayer", JSON.stringify(configLayer));
  }, [configLayer]);

  useEffect(() => {
    if (configLayer != null) return;
    // Push the object directly
    let layers = sessionStorage.getItem("easyMapsLayer");
    setConfigLayer(JSON.parse(layers));
  }, []);
  // fim da atualização de layeres nos maps

  async function handleApiGetConfig() {
    try {
      const response = await api.post("/settings/find", {
        product: "easymaps",
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar as configurações",
          severity: "error",
        });
      } else {
        if (response.data) {
          let dataConfig = response.data;

          if (
            dataConfig?.configuracoes?.geo?.atualizacao < 60000 ||
            !dataConfig?.configuracoes?.geo?.atualizacao
          ) {
            dataConfig.configuracoes.geo.atualizacao = 60000;
          }
          if (
            dataConfig?.configuracoes?.top?.atualizacao < 60000 ||
            !dataConfig?.configuracoes?.top?.atualizacao
          ) {
            dataConfig.configuracoes.top.atualizacao = 60000;
          }
          if (
            dataConfig?.configuracoes?.ftth?.atualizacao < 60000 ||
            !dataConfig?.configuracoes?.ftth?.atualizacao
          ) {
            dataConfig.configuracoes.ftth.atualizacao = 60000;
          }
          setConfig({
            id: dataConfig.id,
            configuracoes: dataConfig.configuracoes,
            redisDisponivel: dataConfig.redisDisponivel,
          });
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }
  async function handleApiGetMaps() {
    try {
      const [responseFindMany, responseFindFtth] = await Promise.all([
        api.get("/easyMaps/map/findMany"),
        api.get("/easyMaps/map/findFtth"),
      ]);

      const extractMaps = (response) => {
        if (response.data?.status === "Error" || !Array.isArray(response.data))
          return [];
        return response.data.map((m) => ({
          id: m.id,
          tipo: m.tipo,
          titulo: m.titulo,
        }));
      };

      const mapsFromFindMany = extractMaps(responseFindMany);
      const mapsFromFtth = extractMaps(responseFindFtth);

      const merged = [...mapsFromFindMany, ...mapsFromFtth];

      const order = [0, 4, 3];
      const sorted = merged.sort((a, b) => {
        const aIdx = order.indexOf(a.tipo);
        const bIdx = order.indexOf(b.tipo);
        const aOrder = aIdx === -1 ? order.length : aIdx;
        const bOrder = bIdx === -1 ? order.length : bIdx;
        return aOrder - bOrder;
      });

      setMaps(sorted);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Erro: Não foi possível carregar os mapas`,
        severity: "error",
      });
    }
  }

  useEffect(() => {
    handleApiGetMaps();
  }, []);

  function findTitleHierarchy(pages, targetLink) {
    for (const page of pages) {
      if (page.link === targetLink) {
        return [page.label];
      }
      if (page.nodes) {
        const foundInNodes = findTitleHierarchy(page.nodes, targetLink);
        if (foundInNodes) {
          return [page.label, ...foundInNodes];
        }
      }
    }
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <MapActionsContext.Provider value={{ menuConfig, setMenuConfig }}>
        <ModulesAlert modulos={modulos} />
        <CssBaseline />
        <Box sx={styles.containerLayout}>
          <TopBar
            setOpenDrawer={setOpenDrawer}
            setOpenRightBar={setOpenRightBar}
            iconLogo={<IconLogo />}
            clientLogo={clientLogo}
            link={"/easyMaps"}
            socket={socket}
            socketCliente={socketCliente}
            colorMode={colorMode}
            setColorMode={setColorMode}
            snackbar={snackbar}
            setSnackbar={setSnackbar}
            openRightBar={openRightBar}
            ocultar={!showSidebar}
            tools={<Config setOpenConfig={setOpenConfig} />}
          />
          <Box sx={styles.containerBody}>
            <SideBar
              items={rightBarPages}
              title="Navegação"
              openRightBar={openRightBar}
              setOpenRightBar={setOpenRightBar}
              openDrawer={openDrawer}
              setOpenDrawer={setOpenDrawer}
              iconLogo={<IconLogo />}
              clientLogo={clientLogo}
              ocultar={!showSidebar}
            />

            <Box component="main" sx={styles.containerOutlet}>
              <Outlet
                context={{
                  config,
                  setConfig,
                  configLocal,
                  setConfigLocal,
                  setOpenConfig,
                  configLayer,
                  setConfigLayer,
                  titlePage,
                  maps,
                }}
              />
            </Box>
          </Box>{" "}
        </Box>
        <ConfiguracaoEasyMapsModal
          open={structuredClone(openConfig)}
          setOpen={setOpenConfig}
          config={config}
          setConfig={setConfig}
          setConfigLocal={setConfigLocal}
          tabDefault={openConfig.tab}
        />
      </MapActionsContext.Provider>
    </ThemeProvider>
  );
}

export default LayoutEasyMaps;
